import {
  QuickStoreCartItemInterface,
  QuickStoreItemInterface,
} from '@focus.cloud/src/backoffice/store/components/storeInterfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface StoreSliceState {
  storePage: string;
  serviceList: QuickStoreItemInterface[];
  cartList: QuickStoreCartItemInterface[];
  codiceIndirizzoFatturazioneSelezionato: string;
  codiceIndirizzoSpedizioneSelezionato: string;
  metodoPagamentoSelezionato: string;
}

const initialState: StoreSliceState = {
  storePage: 'articles',
  serviceList: [],
  cartList: [],
  codiceIndirizzoFatturazioneSelezionato: '',
  codiceIndirizzoSpedizioneSelezionato: '',
  metodoPagamentoSelezionato: '',
};

export const StoreSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    setStorePage(state: StoreSliceState, action: PayloadAction<string>) {
      state.storePage = action.payload;
    },
    setStoreServiceList(
      state: StoreSliceState,
      action: PayloadAction<QuickStoreItemInterface[]>,
    ) {
      state.serviceList = action.payload;
    },
    setStoreCartList(
      state: StoreSliceState,
      action: PayloadAction<QuickStoreCartItemInterface[]>,
    ) {
      state.cartList = action.payload;
    },
    setCodiceIndirizzoFatturazioneSelezionato(
      state: StoreSliceState,
      action: PayloadAction<string>,
    ) {
      state.codiceIndirizzoFatturazioneSelezionato = action.payload;
    },
    setCodiceIndirizzoSpedizioneSelezionato(
      state: StoreSliceState,
      action: PayloadAction<string>,
    ) {
      state.codiceIndirizzoSpedizioneSelezionato = action.payload;
    },
    setMetodoPagamentoSelezionato(
      state: StoreSliceState,
      action: PayloadAction<string>,
    ) {
      state.metodoPagamentoSelezionato = action.payload;
    },
    resetQuickStoreState(state: StoreSliceState) {
      state.storePage = initialState.storePage;
      state.codiceIndirizzoFatturazioneSelezionato =
        initialState.codiceIndirizzoFatturazioneSelezionato;
      state.codiceIndirizzoSpedizioneSelezionato =
        initialState.codiceIndirizzoSpedizioneSelezionato;
      state.metodoPagamentoSelezionato =
        initialState.metodoPagamentoSelezionato;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setStorePage,
  setStoreServiceList,
  setStoreCartList,
  setCodiceIndirizzoFatturazioneSelezionato,
  setCodiceIndirizzoSpedizioneSelezionato,
  resetQuickStoreState,
  setMetodoPagamentoSelezionato,
} = StoreSlice.actions;
export default StoreSlice.reducer;
